import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign "ResizeObserver loop completed with undelivered notifications"
// warning that CRA dev-overlay surfaces as a fatal error. Common with Radix UI
// Select/Dialog combinations. Does not affect production builds.
const suppressResizeObserver = (message) =>
  typeof message === "string" && message.includes("ResizeObserver loop");

window.addEventListener("error", (e) => {
  if (suppressResizeObserver(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  if (suppressResizeObserver(e.reason?.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
